import React from 'react';

const TodosError = () => {
  return <p>Desespérate, hubo un error...</p>
}

export { TodosError }
